var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlassSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "magnifying-glass-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #cacaca } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m13.5 12.1q0.1 0.2 0.1 0.4 0 0.2-0.1 0.4 0 0.2-0.2 0.3-0.1 0.1-0.1 0.2-0.1 0-0.2 0-0.1 0.1-0.2 0.1-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0-0.2-0.1-0.1 0-0.2 0 0-0.1-0.1-0.2l-2.8-2.8q-0.3 0.2-0.7 0.4-0.3 0.2-0.7 0.3-0.4 0.1-0.7 0.1-0.4 0.1-0.8 0.1c-2.8 0-5-2.2-5-5 0-2.8 2.2-5 5-5 2.8 0 5 2.2 5 5q0 0.3 0 0.7-0.1 0.3-0.2 0.7-0.1 0.3-0.2 0.6-0.2 0.4-0.3 0.6l2.8 2.9q0.2 0.1 0.2 0.3zm-3.9-5.8c0-1.9-1.5-3.4-3.4-3.4-1.9 0-3.4 1.5-3.4 3.4 0 1.9 1.5 3.4 3.4 3.4 1.9 0 3.4-1.5 3.4-3.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSvg);
export default __webpack_public_path__ + "static/media/magnifying-glass-svg.07fbeecf94d360987432c6f5dfe58b49.svg";
export { ForwardRef as ReactComponent };